import * as React from "react";
import { Typography } from "@mui/material";

interface priceStrProps {
  style?: object,
}

const PriceStr: React.FC<priceStrProps> = ({ style }) => {
  return (
    <Typography
      component={"span"}
      sx={{
        fontSize: "18px",
        color: "#ffffff",
        fillRule: "evenodd",
        ...style
      }}
    >
      <span>0.20</span>
      <span style={{ position: "relative", top: "-2px", left: "5px", }}>ETH</span>
    </Typography>


  );
};

export default PriceStr;